import React, { useEffect, useRef, useState } from "react";
import "./InvoicePrint.css";
import "firebase/compat/firestore";
import { formatTotal, getDiscount, getExpedited, getHardCopyPrice, getShortOrderNo, getTotal, signaturePrice } from "../Data/Functions";
import { firestore } from "../firebase.config"; 
import { AlertCircle } from "react-feather";
import { useReactToPrint } from "react-to-print";
import {ReactComponent as EVERBARY_LOGO} from "../assets/icons/everbary-logo-black.svg";
import { useSpring, animated } from "react-spring";

export const InvoiceToPrint = ({ orderInfo, downloadOrder, setDownloadOrder, setShowBtns = () => {}}) => {

   const [teamData, setTeamData] = useState(null);
   const [teamOwner, setTeamOwner] = useState(null);
   const [autoBilling, setAutoBilling] = useState(false);
   const [loading, setLoading] = useState(false);

  const ref = useRef();
   
  const getInvoiceNumber = (order) => {
    return "2" + getShortOrderNo(order.orderNumber);
  };

  const handlePrint = useReactToPrint({
      content: () => ref.current,
      documentTitle: `Invoice ${orderInfo.orderInvoiceNumber ?? getInvoiceNumber(orderInfo)}`,
  });

  useEffect(() => {
    if(orderInfo && downloadOrder === orderInfo.id){
        handlePrint()
        setDownloadOrder("");
    }
  }, 
  [downloadOrder, orderInfo]);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const splitted = date.toDateString().split(" ");

    return splitted[1] + " " + splitted[2] + ", " + splitted[3];
  };


  useEffect(() => {
    if(!orderInfo){
      return;
    }
    try{
      setLoading(true);
      if (orderInfo && orderInfo.teamId) {
        getInvoiceData(orderInfo.orderInvoiceId);
        getTeamOwner(orderInfo.teamId);
      } else {
        setTeamData(null);
        setTeamOwner(null);
        setAutoBilling(false);
      }
    }catch(error){
      console.log(error)
    }finally{
      setLoading(false);
    }

  }, [orderInfo])
    
    
  const getInvoiceData = async (invoiceId) => {
    try{
      if (!invoiceId) {
        setAutoBilling(orderInfo && orderInfo.paypalOrderID === "auto-billing");
      };
      await firestore.collection("orderInvoices").doc(invoiceId).get().then((doc) => {
        if(doc.exists){
          setAutoBilling(doc.data().type && doc.data().type === "multipleInvoice");
          getTeamData(doc.data().teamId);
        }
      });
      
  }catch(error){
      console.log(error)
    }
  }

  const getTeamData = async (teamId) => {
    try{
      if (!teamId) return;
      await firestore.collection("teams").doc(teamId).get().then((doc) => {
        if(doc.exists){
          setTeamData({ id: doc.id, ...doc.data() });
        }
      });
     
  }catch(error){
      console.log(error)
    }
  }

  const getTeamOwner = async (teamId) => {
    try{
      if (!teamId ) return;
      firestore.collection("users").where("teamId", "==", teamId).where("teamRole", "==", "owner").get().then((qSnap) => {
        if(!qSnap.empty){
          const user = qSnap.docs[0].data();
          setTeamOwner({ id: qSnap.docs[0].id, ...user });
        }
      });
    }catch(error){
      console.log(error)
    }
  }
  
  if (!orderInfo || loading) {
    return <div>Loading,Please wait<span className="loadingDots">...</span></div>;
  }else{
    setShowBtns(true);
  }
  return (
      <div
        ref={ref}
        className={`bg-[#f6f6f6] font-sans antialiased text-sm leading-relaxed h-dvh  mx-auto py-8 px-12 flex flex-col justify-between h-full`}
      >
        <table
          border="0"
          cellPadding="0"
          cellSpacing="0"
          className="border-separate w-full "
        >
          <tbody>
            <tr>
              <td className="font-sans text-sm align-top block mx-auto mb-4  p-2.5">
                <div className="box-border block mx-auto p-2.5">
                  <EVERBARY_LOGO/>
                </div>
              </td>
            </tr>
            <tr>
              <td>
              <table className="w-full border-collapse">
                <tbody>
                <tr>
                  <td className="w-1/2 align-top p-4">
                    <h2 className={`text-[14px] font-bold ${autoBilling ? "text-[#ff7c1d]" : "text-[#1eb8bc]"}`}>
                      Invoice to:
                    </h2>
                    <p className="text-[14px] font-normal text-[#2d2d2d] my-2 tracking-tight leading-[13px]">
                      {orderInfo.teamId && teamData ? teamData.name : orderInfo.name}
                    </p>
                    <p className="text-[12px] font-normal text-[#969696] tracking-tight leading-[13px]">
                      {autoBilling && orderInfo.teamId && teamOwner ? teamOwner.name : orderInfo.email}
                    </p>
                  </td>
                  <td className="w-1/2 align-top p-4 text-left">
                    <h2 className={`text-[14px] font-bold mb-0 ${autoBilling ? "text-[#ff7c1d]" : "text-[#1eb8bc]"}`}>
                      {autoBilling ? "Reference Invoice – Not Payable" : 
                      `Invoice #${orderInfo.orderInvoiceNumber ? orderInfo.orderInvoiceNumber : getInvoiceNumber(orderInfo)}`}
                    </h2>
                    <p className="flex justify-between border-b border-[#e0e0e0] mt-2 pb-2">
                      <strong className="text-[12px] text-[#2d2d2d]">Order:</strong>
                      <span className="text-[12px] text-[#2d2d2d]">
                        #{orderInfo.orderNumber}
                      </span>
                    </p>
                    <p className="flex justify-between mt-0 py-2">
                      <strong className="text-[12px] text-[#2d2d2d]">Date:</strong>
                      <span className="text-[12px] text-[#2d2d2d]">
                        {formatDate(orderInfo.timestamp)}
                      </span>
                    </p>
                    {orderInfo.teamId && orderInfo.clientFirstName && <p className="flex justify-between mt-0 py-2">
                      <strong className="text-[12px] text-[#2d2d2d]">Your Client:</strong>
                      <span className="text-[12px] text-[#2d2d2d]">
                        {orderInfo.clientFirstName + " " + orderInfo.clientLastName || ""}
                      </span>
                    </p>}
                  </td>
                </tr>
                </tbody>
              </table>
              </td>
            </tr>

            <tr>
              <td className="p-4 bg-[#fafafa] shadow-lg rounded-2xl my-12 w-full">
                <table className="invoicePrintTable w-full border-collapse rounded-2xl">
                  <thead className="p-4">
                    <tr>
                      <th className={`invoiceHeader ${autoBilling ? "text-[#ff7c1d]" : "text-[#1eb8bc]"}`}>Description</th>
                      <th className={`invoiceHeader ${autoBilling ? "text-[#ff7c1d]" : "text-[#1eb8bc]"}`}>Qty.</th>
                      <th className="pb-2 border-b border-[#e0e0e0]"></th>
                      <th className={`invoiceHeader ${autoBilling ? "text-[#ff7c1d]" : "text-[#1eb8bc]"}`}>Unit Price</th>
                      <th className={`invoiceHeader ${autoBilling ? "text-[#ff7c1d]" : "text-[#1eb8bc]"} `}>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="invoiceItem">Certified Translation</td>
                      <td className="invoiceItem">
                        {parseInt(orderInfo.pagesCount, 10) + (orderInfo.pagesCount === "1" ? " page" :" pages")}
                      </td>
                      <td className="invoiceItem"></td>
                      <td className="invoiceItem">$24.95</td>
                      <td className="invoiceItem">
                        {formatTotal(orderInfo.pagesCount * 24.95, 10)}
                      </td>
                    </tr>

                    {(orderInfo.expeditedPlus || orderInfo.expedited) && (
                      <tr>
                        <td className="invoiceItem">
                          Expedited Turnaround{" "}
                          {orderInfo.expeditedPlus ? "Plus" : ""}
                        </td>
                        <td className="invoiceItem">
                          {" "}
                          {parseInt(orderInfo.pagesCount, 10)} pages
                        </td>
                        <td className="invoiceItem"></td>
                        <td className="invoiceItem">
                          {orderInfo.expeditedPlus ? "$9.98" : "$4.99"}
                        </td>
                        <td className="invoiceItem">{getExpedited(orderInfo)}</td>
                      </tr>
                    )}

                    {orderInfo.notarization && (
                      <tr>
                        <td className="invoiceItem">Notarization</td>
                        <td className="invoiceItem">1</td>
                        <td className="invoiceItem"></td>
                        <td className="invoiceItem">$34.90</td>
                        <td className="invoiceItem">
                          {orderInfo.notarization ? "$34.90" : "0"}
                        </td>
                      </tr>
                    )}

                    {orderInfo.hardCopy &&
                      orderInfo.hardCopyExtra.country !== "" &&
                      orderInfo.hardCopyExtra.method !== "" && (
                        <tr>
                          <td className="invoiceItem">{`USPS ${
                            orderInfo.hardCopyExtra.method
                              .charAt(0)
                              .toUpperCase() +
                            orderInfo.hardCopyExtra.method.slice(1)
                          } Mail ${
                            ![
                              "United States",
                              "Puerto Rico",
                              "U.S. Virgin Islands",
                            ].includes(orderInfo.hardCopyExtra.country)
                              ? "International"
                              : ""
                          }`}</td>
                          <td className="invoiceItem"> 1 </td>
                          <td className="invoiceItem"></td>
                          <td className="invoiceItem">
                            $
                            {getHardCopyPrice(
                              orderInfo.hardCopyExtra.country,
                              orderInfo.hardCopyExtra.method,
                              false,
                              orderInfo
                            )}
                          </td>
                          <td className="invoiceItem">
                            $
                            {getHardCopyPrice(
                              orderInfo.hardCopyExtra.country,
                              orderInfo.hardCopyExtra.method,
                              false,
                              orderInfo
                            )}
                          </td>
                        </tr>
                      )}

                    {orderInfo.hardCopy &&
                      orderInfo.hardCopyExtra.requireSignature && (
                        <tr>
                          <td className="invoiceItem">
                            Signature Required for Delivery
                          </td>
                          <td className="invoiceItem">1</td>
                          <td className="invoiceItem"></td>
                          <td className="invoiceItem">$4.99</td>
                          <td className="invoiceItem">
                            {orderInfo.hardCopy &&
                            orderInfo.hardCopyExtra.requireSignature
                              ? `$${signaturePrice(true, orderInfo)}`
                              : 0}
                          </td>
                        </tr>
                      )}

                    <tr>
                      <td></td>
                      <td></td>
                      <td className="font-bold text-[#575757] invoiceItem">
                        Subtotal
                      </td>
                      <td className="invoiceItem"></td>
                      <td className="invoiceItem">{formatTotal(getTotal(orderInfo))}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td className="font-bold text-[#575757] invoiceItem">
                        Discount
                      </td>
                      <td className="invoiceItem"></td>
                      <td className="invoiceItem"> -{formatTotal(getDiscount(orderInfo))}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td className={`invoiceHeader !border-none py-2 ${autoBilling ? "text-[#ff7c1d]" : "text-[#1eb8bc]"}`}>Total</td>
                      <td></td>
                      {!autoBilling ? <td className={`invoiceHeader !border-none py-2 `}>{formatTotal(getTotal(orderInfo) - getDiscount(orderInfo))}</td>
                      : <td className={`invoiceHeader !border-none py-2 `}>
                        <div className="text-[#fff] bg-[#ff7c1d] rounded-2xl flex gap-1 items-center justify-center px-2 py-1 max-w-fit">
                        <AlertCircle width={15} height={15} color="#fff"/>
                        {formatTotal(getTotal(orderInfo) - getDiscount(orderInfo))}
                        </div>
                        </td>
                        }
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>

        </table>

        {autoBilling && <table className="w-full">
            <tbody>
              <tr>
                <td className="w-full text-center">
                  <div className="inline-block max-w-[80%] bg-white p-5 rounded-xl shadow-md border border-gray-200 text-left">
                    <div className="flex items-center mb-3 justify-center gap-1">
                      <AlertCircle width={20} height={20} color="#ff7c1d"/>
                      <h2 className="text-[#ff7c1d] font-semibold text-14">Important Note</h2>
                    </div>
                    <p className="text-[#575757] text-10 mb-2">
                      This is a reference document for your records to help track costs per client. It is not an official invoice and cannot be paid separately.
                    </p>
                    <p className="text-[#575757] text-10">
                      As you are on a billing term, the total amount for this order will be included in your consolidated invoice at the end of the billing period.
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>}

          <table className="mt-8">
            <tbody>
              {!autoBilling && <tr>
                <td className="mx-auto mb-8">
                  <h1 className="text-center text-2xl font-semibold text-[#1eb8bc]">
                    Thank you for choosing <span className="font-black">eVerbary!</span>
                  </h1>
                </td>
              </tr>}

              <tr>
                <td className="h-8"></td>
              </tr>
              <tr>
                <td>
                <table className="w-full">
                  <tbody>
                    <tr className="w-full flex justify-between">
                      <td className="p-4">
                        <div className="flex items-center gap-2">
                          <img
                            src="https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/eVerbaryLogo%2Ficons%2Fcall.svg?alt=media&token=715ea837-eec5-4faf-a7f8-1642c2fab565"
                            alt="call"
                            className="w-[18px] h-[18px]"
                          />
                          <span className="text-[14px] font-normal text-[#2d2d2d]">
                            +1 (505) 916-8399
                          </span>
                        </div>
                      </td>
                      <td className="p-4">
                        <div className="flex items-center gap-2">
                          <img
                            src="https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/eVerbaryLogo%2Ficons%2FblueEnvelop.svg?alt=media&token=adbff61f-4224-4292-808f-50acafd135da"
                            alt="email"
                            className="w-[18px] h-[18px]"
                          />
                          <span className="text-[14px] font-normal text-[#2d2d2d]">
                            support@everbary.com
                          </span>
                        </div>
                      </td>
                      <td className="p-4">
                        <div className="flex items-start gap-2">
                          <img
                            src="https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/eVerbaryLogo%2Ficons%2Flocation.svg?alt=media&token=e991ba05-61a5-4e4e-94ec-09fd591bdb88"
                            alt="location"
                            className="w-[18px] h-[18px] mt-1"
                          />
                          <span className="text-[14px] font-normal text-[#2d2d2d] leading-[1.4]">
                            1209 Mountain Road Pl NE Ste N <br />
                            Albuquerque, NM 87110 <br />
                            United States
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                </td>
              </tr>
            </tbody>
        </table>
      </div>
  );
};